import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Components from './components/components';
import HotTopicDetail from '../components/hotTopicDetail';

import './ransomware.theme.less';
import './ransomware.less';

export interface IRansomwareProps {
  topicName: string;
  topicSettings: any[];
}

export function Ransomware(props: IRansomwareProps) {
  return (
    <Routes key={props.topicName}>
      <Route
        path="/"
        element={
          <HotTopicDetail
            settings={props.topicSettings}
            components={Components}
          />
        }
      />
    </Routes>
  );
}
